import { gql } from 'urql';
import { OwnershipFragment } from './ownershipFragment';
import { MonetaryAmountDataPointGroupFragment } from './dataPointFragments';

export const NoteReceivableFragment = gql`
  ${OwnershipFragment}
  ${MonetaryAmountDataPointGroupFragment}
  fragment NoteReceivableFragment on NoteReceivable {
    __typename
    id
    householdID
    createdAt
    updatedAt
    changeToken
    name
    notes
    ownedValue {
      __typename
      value
      currencyCode
    }
    owners {
      __typename
      id
      ownerType
      ... on Person {
        givenName
        familyName
      }
      ... on Business {
        name
      }
    }
    ownership {
      ...OwnershipFragment
    }
    value {
      ...MonetaryAmountDataPointGroupFragment
    }
  }
`;
